import { useApiUrl } from '@gemini/lux-ds-pms';
import { OBRoutes } from '@utils/apiRoutes';
import { HourSlot } from '@utils/interfaces';
import { useOBMutation } from './useOBMutation';

interface CreateReservationRequest {
  practiceId: string;
}

interface CreateReservationResponse {
  reservationId: string;
  timer: string;
}

const useUpdateClaimRemittance = ({ practiceId }: CreateReservationRequest) => {
  const url = useApiUrl(
    OBRoutes.ReservationSelection,
    'ONLINEBOOKING_CLIENT_BFF_API_BASE_URL',
  )?.replace('##practiceId', practiceId);

  return useOBMutation<CreateReservationResponse, HourSlot>(url || '', {
    method: 'POST',
  });
};

export default useUpdateClaimRemittance;
